import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        marginTop: 30,
        marginLeft: 10,
        marginRight: 10
    },
}))
